import lozad from 'lozad';

const lazyLoadBackground = () => {
    const observer = lozad('.lazy', {
        load: function (el) {
            const image = el.getAttribute('data-original');
            const bgImage = el.getAttribute('data-background-image');
            // Custom implementation to load an element
            if (image) {
                el.src = image;
            } else if (bgImage) {
                el.style.backgroundImage = `url('${bgImage}')`;
                el.style.backgroundRepeat = 'no-repeat';
            }
        }
    });
    observer.observe();
};

export default lazyLoadBackground;